import {createTheme, ThemeOptions} from "@mui/material";
import {colorPastelBlue, DEFAULT_THEME_OPTIONS, nightGray} from "@/shared/colors";
import {BORDER_RADIUS_LARGE, CARD_SHADOW, PD_LG, PD_XSM} from "@/shared/dimens";
import {SiteTemplate} from "../../types";
import {AddressSection} from "./AddressSection";
import {ContactSection} from "./ContactSection";
import {FaqSection} from "./FaqSection";
import {FooterSection} from "./FooterSection";
import {GallerySection} from "./GallerySection";
import {HeaderSection} from "./HeaderSection";
import {HeroSection} from "./HeroSection";
import {HighlightSection} from "./HighlightSection";
import {PromoSection} from "./PromoSection";
import {ServicesSection} from "./ServicesSection";
import {StatsSection} from "./StatsSection";
import {TeamSection} from "./TeamSection";
import {TestimonialsSection} from "./TestimonialsSection";
import {FontManager} from "@/shared/fonts";

const fontManager = FontManager.getInstance();

export const HeadingFont = fontManager.getFont("Instrument_Serif");
export const BodyFont = fontManager.getFont("Inter");

export const THEME_OPTIONS: ThemeOptions = {
  ...DEFAULT_THEME_OPTIONS,
  components: {
    ...DEFAULT_THEME_OPTIONS.components,
    MuiPaper: {
      styleOverrides: {
        elevation: {
          boxShadow: CARD_SHADOW,
        },
      },
    },
    MuiAccordion: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          '&:before': {
            display: 'none',
          },
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true
      },
      styleOverrides: {
        root: {
          fontWeight: "bold",
          borderRadius: BORDER_RADIUS_LARGE,
          minHeight: 48,
          paddingTop: PD_XSM,
          paddingBottom: PD_XSM,
          paddingLeft: PD_LG,
          paddingRight: PD_LG,
          textTransform: "none",
          borderColor: "#ccc",
        },
      }
    },
    MuiTooltip: {
      styleOverrides: {
        arrow: {
          backgroundColor: nightGray,
        },
        tooltip: {
          backgroundColor: nightGray,
          fontSize: "90%",
        }
      }
    }
  },
  typography: {
    h1: {
      fontWeight: "bold",
      letterSpacing: -1.3,
      fontFamily: HeadingFont.style.fontFamily,
    },
    h2: {
      fontWeight: "bold",
      letterSpacing: -1.2,
      fontFamily: HeadingFont.style.fontFamily,
      fontSize: "440%",
    },
    h3: {
      fontWeight: "bold",
      letterSpacing: -1.1,
      fontFamily: HeadingFont.style.fontFamily,
    },
    h4: {
      fontWeight: "bold",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h5: {
      fontWeight: "bold",
      fontFamily: HeadingFont.style.fontFamily,
    },
    h6: {
      fontWeight: "bold",
      fontFamily: HeadingFont.style.fontFamily,
    },
    fontSize: 15,
    fontFamily: BodyFont.style.fontFamily,
  },
  palette: {
    primary: {
      main: "#111",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fff",
      contrastText: "#000",
    },
  }
};

export const COLORADO_TEMPLATE: SiteTemplate = {
  name: "colorado",
  text: "Colorado",
  theme: createTheme(THEME_OPTIONS),
  themeExtras: {
    highlightColor: colorPastelBlue,
  },
  PageSections: {
    AddressSection: AddressSection,
    ContactSection: ContactSection,
    FaqSection: FaqSection,
    FooterSection: FooterSection,
    GallerySection: GallerySection,
    HeaderSection: HeaderSection,
    HeroSection: HeroSection,
    HighlightSection: HighlightSection,
    PromoSection: PromoSection,
    ServicesSection: ServicesSection,
    StatsSection: StatsSection,
    TeamSection: TeamSection,
    TestimonialsSection: TestimonialsSection,
  }
}